import { useNavigate } from "react-router-dom";
import { pageMeta } from "../config/site";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

export function NotFoundPage() {
  const navigate = useNavigate();
  useDocumentTitle(pageMeta.notFound.title, pageMeta.notFound.description);

  return (
    <main className="not-found page-section" data-screen-label="404">
      <span className="page-kicker">404</span>
      <h1>页面未找到</h1>
      <p>您访问的地址不存在，或内容已迁移到新路径。</p>
      <div className="hero-actions">
        <button
          className="button button--primary"
          type="button"
          onClick={() => navigate("/")}
        >
          返回首页
        </button>
        <button
          className="button button--ghost"
          type="button"
          onClick={() => navigate("/security")}
        >
          安全与合规
        </button>
      </div>
    </main>
  );
}
